export default "__VITE_ASSET__ZW8OnuVL__"